export const eventNames = {
    EVENT_CONNECT: 'Connect With Attendees',
    EVENT_PROPERTIES: 'Properties',
};
